const LINKS = {
  aamKeretSzamitas: 'https://quickipedia.riport.app/hc/hu/articles/360021383180',
  aamKeretAtlepesFeladataok: 'https://quickipedia.riport.app/hc/hu/articles/360018812992',
  chat: '#', // TODO
  documentAiEULA: 'https://legal.riport.app/adatvedelmi-tajekoztato-3#_luqWA',
  eula: 'https://legal.riport.app/adatvedelmi-tajekoztato-3',
  evRegistry: 'https://nav.gov.hu/adatbazisok/adatbleker/egyeni-vallalkozok-nyilvantartasa',
  expressPayment: 'https://quickipedia.riport.app/hc/hu/articles/7254018512924-Expressz-fizetés-funkció',
  defaultWallet:
    'https://quickipedia.riport.app/hc/hu/articles/7254268263196-Fizetettre-%C3%A1ll%C3%ADt%C3%A1s-utal%C3%A1si-csomaggal',
  functionsList: 'https://www.helloquick.riport.app/funkciok',
  fundamentals: 'https://quickipedia.riport.app/hc/hu/articles/6153105598236',
  kataBevallasInactivePeriodsInfo: 'https://quickipedia.riport.app/hc/hu/articles/7333504331292',
  kataBevallasTudascentrum: 'https://quickipedia.riport.app/hc/hu/articles/23873315646236',
  paidThroughMoreInformation: 'https://quickipedia.riport.app/hc/hu/articles/7013040208924',
  subscriptionChange:
    'https://quickipedia.riport.app/hc/hu/articles/10015528504860-Csomagv%C3%A1lt%C3%A1ssal-kapcsolatos-tudnival%C3%B3k',
  szamlazz: 'https://szamlazz.hu',
  szamlazzAutokassza: 'https://www.szamlazz.hu/egyedi-megoldasok/autokassza',
  szamlazzConnect: 'https://quickipedia.riport.app/hc/hu/articles/5858080562332',
  szamlazzKeretEsAdofigyelo:
    'https://www.szamlazz.hu/keret-es-adofigyelo?utm_source=online_konyvelo&utm_medium=tms&utm_campaign=online_konyvelo&utm_content=elutasito-flow-button',
  szamlazzLoginRedirect: 'https://www.szamlazz.hu/szamla/?action=directlogin&targetaction=quicklogin',
  szamlazzMainPage: 'https://www.szamlazz.hu/szamla/?page=dijcsomag',
  szamlazzAuth:
    'https://www.szamlazz.hu/szamla/?action=directlogin&targetaction=quicklogin&utm_source=loginform&utm_medium=tms&utm_campaign=tms&utm_id=TMS',
  szja22BevallasTudascentrum: 'https://quickipedia.riport.app/hc/hu/articles/8496960920860',
  szja23BevallasTudascentrum:
    'https://quickipedia.riport.app/hc/hu/articles/13571910636188-23SZJA-bevall%C3%A1s-kit%C3%B6lt%C3%A9si-seg%C3%A9dlet-%C3%A1tal%C3%A1nyad%C3%B3z%C3%B3-egy%C3%A9ni-v%C3%A1llalkoz%C3%B3k-r%C3%A9sz%C3%A9re',
  szja24BevallasTudascentrum:
    'https://quickipedia.riport.app/hc/hu/articles/18810799699740-24SZJA-bevall%C3%A1s-kit%C3%B6lt%C3%A9si-seg%C3%A9dlet-%C3%A1tal%C3%A1nyad%C3%B3z%C3%B3-egy%C3%A9ni-v%C3%A1llalkoz%C3%B3k-r%C3%A9sz%C3%A9re',
  szja25BevallasTudascentrum:
    'https://quickipedia.riport.app/hc/hu/articles/25642559887644-25SZJA-bevall%C3%A1s-kit%C3%B6lt%C3%A9si-seg%C3%A9dlet-%C3%A1tal%C3%A1nyad%C3%B3z%C3%B3-egy%C3%A9ni-v%C3%A1llalkoz%C3%B3k-r%C3%A9sz%C3%A9re',
  tbjSzochoBevallasTudascentrum:
    'https://quickipedia.riport.app/hc/hu/articles/6102402397212-58-as-bevall%C3%A1s-XML-bet%C3%B6lt%C3%A9se-%C3%81NYK-ba',
  tbjSzocho2358ANYK: 'https://quickipedia.riport.app/hc/hu/articles/6102402397212',
  tbjSzocho2358ONYA: 'https://quickipedia.riport.app/hc/hu/articles/6362345616412',
  tmsInfo: 'https://www.szamlazz.hu/keret-es-adofigyelo-egyeni-vallalkozoknak/',
  terms: 'https://legal.riport.app/altalanos-szerzodesi-feltetelek-2',
  receiveNewNotificationsEmail:
    'https://quickipedia.riport.app/hc/hu/articles/15423684054940-Automatikus-heti-jelent%C3%A9s-az-olvasatlan-sz%C3%A1ml%C3%A1kr%C3%B3l-%C3%A9s-dokumentumokr%C3%B3l',
  receiveUnapprovedEmail:
    'https://quickipedia.riport.app/hc/hu/articles/18865784968860-E-mail-%C3%A9rtes%C3%ADt%C3%A9sek-hi%C3%A1nyz%C3%B3-j%C3%B3v%C3%A1hagy%C3%A1sr%C3%B3l',

  navM2MEula:
    'https://www.szamlazz.hu/wp-content/uploads/2026/02/Adatkezelesi_tajekoztato_Keret_es_adofigyelo_uj_funkciojaval_osszefuggo_elozetes_felmeressel_kapcsolatosan_Szamlazzhu.20260227_final.pdf',
  navM2MTerms: 'https://www.szamlazz.hu/wp-content/uploads/2026/03/ASZF.kiegeszito_Keret_es_adofigyelo_202602.docx.pdf',
}

export default LINKS
